// extracted by mini-css-extract-plugin
export default {"background":"Memories_background__NQuas","memoriesSection":"Memories_memoriesSection__yhmlD"};